import { Service } from '@angular/core'

function _window(): Window {
  // return the global native browser window object
  return window
}

@Service()
export class WindowService {
  nativeWindow(): Window {
    return _window()
  }
}
